var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBlueMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 4,
    fill: "#E9F3FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.43026 7.83753C7.35363 7.84002 7.27828 7.85785 7.20866 7.88999C7.13905 7.92212 7.07659 7.96789 7.02499 8.0246C6.97338 8.0813 6.93368 8.14778 6.90823 8.22011C6.88278 8.29243 6.8721 8.36913 6.87682 8.44565C6.95338 9.75815 7.31432 12.9607 9.04245 14.9578C11.1118 17.3641 13.8068 18.1932 16.5718 18.0707C16.72 18.0618 16.8594 17.997 16.9617 17.8894C17.064 17.7818 17.1217 17.6394 17.1231 17.491V15.3888C17.1213 15.1926 17.0538 15.0028 16.9312 14.8496C16.8086 14.6965 16.6381 14.589 16.4471 14.5444L15.0624 14.2382C14.8912 14.2016 14.7129 14.2174 14.5507 14.2833C14.3884 14.3492 14.2497 14.4622 14.1524 14.6078L13.8462 15.0716C13.8181 15.114 13.776 15.1453 13.7273 15.1601C13.6786 15.1749 13.6263 15.1722 13.5793 15.1525C12.8749 14.8485 10.0684 13.536 9.75995 11.3222C9.7539 11.2795 9.76065 11.2359 9.77934 11.1969C9.79802 11.158 9.82781 11.1255 9.86495 11.1035L10.4206 10.7644C10.573 10.67 10.6927 10.531 10.7635 10.3663C10.8343 10.2015 10.8528 10.019 10.8165 9.84346L10.5124 8.43471C10.468 8.23733 10.3565 8.06145 10.197 7.93701C10.0374 7.81258 9.83971 7.74727 9.63745 7.75221L7.43026 7.83753Z",
    stroke: "#0095FF",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlueMobile);
export default __webpack_public_path__ + "static/media/iconBlueMobile.ba530e0f3f69b62f3cb164adc10f2ac7.svg";
export { ForwardRef as ReactComponent };